export default __webpack_public_path__ + "static/media/Home-foto-header-corporate-Tower-viajes-mobile.3a4a54cb.jpg";